import React, { Component } from 'react';
import { View, Text, Platform, TouchableWithoutFeedback } from 'react-native';

import { VFButton, VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { getThemeImages } from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import PropTypes from 'prop-types';

import LoginTestKeys from '../../Utils/LoginTestKeys';

import styles from './BlockBox.Styles';

class BlockBox extends Component {
  constructor(props) {
    super(props);
  }
  renderText = () => {
    const { theme, text, textPlaceholder } = this.props;
    const translatedText = ContentManager.translate(text, ['%1$s']);
    const textArr = translatedText.split('%1$s');

    const accessibilityObject =
      Platform.OS === 'android'
        ? { accessibilityLabel: LoginTestKeys.loginBlockedDesc }
        : { testID: LoginTestKeys.loginBlockedDesc };

    return (
      <Text style={styles.message} {...accessibilityObject}>
        <VFText style={styles.txtBlockMessage(theme)} i18nKey={textArr[0]} />
        <VFText style={styles.txtEmail(theme)} i18nKey={textPlaceholder} />
        <VFText style={styles.txtBlockMessage(theme)} i18nKey={textArr[1]} />
      </Text>
    );
  };

  render() {
    const {
      theme,
      onClose,
      onPrimaryBtnPress,
      onSecondaryBtnPress,
      title,
      subtitle,
      primaryBtnTitle,
      secondaryBtnTitle,
    } = this.props;
    const Images = getThemeImages(theme.name);
    return (
      <View style={styles.container} accessibilityLabel={LoginTestKeys.attemptsWarningContainer}>
        <View style={styles.darkOverlay} />

        <View
          style={styles.blockBox(theme)}
          accessibilityLabel={LoginTestKeys.attemptsWarningLayout}
        >
          <TouchableWithoutFeedback onPress={onClose}>
            <Icon
              type="image"
              accessibilityLabel={LoginTestKeys.loginBlockedCloseIcon}
              name={Images.ic_close}
              size={24}
              style={styles.closeButton}
            />
          </TouchableWithoutFeedback>

          <VFText
            style={styles.title(theme)}
            i18nKey={title}
            accessibilityLabel={LoginTestKeys.loginBlockedTitle}
          />

          <VFText
            style={styles.subTitle(theme)}
            i18nKey={subtitle}
            accessibilityLabel={LoginTestKeys.loginBlockedSubTitle}
          />

          {this.renderText()}

          <VFButton
            textStyle={styles.txtResetAccount}
            title={primaryBtnTitle}
            style={styles.btnResetAccount}
            onPress={onPrimaryBtnPress}
            textAccessibilityLabel={LoginTestKeys.loginResetButton}
            testID={LoginTestKeys.loginResetButton}
            type="primary"
          />
          <VFButton
            textStyle={styles.txtDifferentAccount(theme)}
            title={secondaryBtnTitle}
            style={styles.btnDifferentAccount}
            onPress={onSecondaryBtnPress}
            textAccessibilityLabel={LoginTestKeys.loginDiffAccount}
            testID={LoginTestKeys.loginDiffAccount}
            type="secondary"
          />
        </View>
      </View>
    );
  }
}

BlockBox.propTypes = {
  onPrimaryBtnPress: PropTypes.func,
  onSecondaryBtnPress: PropTypes.func,
  onClose: PropTypes.func,
  theme: PropTypes.object,
  textPlaceholder: PropTypes.string,
  primaryBtnTitle: PropTypes.string,
  secondaryBtnTitle: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default BlockBox;
